/*@ngInject*/
module.exports = function ($q, publicObjectsService, $scope, data, $uibModalInstance) {
    const vm = this;

    vm.modal = data;
    vm.modalInstace = $uibModalInstance;
    vm.showErrors = false;
    vm.now = new Date();

    $scope.componentImageFileChange = function () {
        if (vm.modal.data.image_file) {
            return true;
        }
        const fileInput = document.getElementById('questionImageFileInput');
        vm.modal.data.imageSelected = fileInput && !!fileInput.files && !!fileInput.files.length;
        $scope.$digest();
    };

    vm.changeNamesFromFile = (event) => {
        const files = event.target.files;
        if (files) {
            if (!vm.modal.data.name) {
                vm.modal.data.name = {
                    est: {},
                    eng: {},
                    rus: {},
                };
            }
            for (let language in vm.modal.data.name) {
                let name = vm.modal.data.name[language];
                if (!name.value) {
                    name.value = files[0].name.split('.').slice(0, -1).join('.');
                }
            }
            $scope.$apply();
        }
    };

    vm.saveComponent = function () {
        vm.modal.showErrors = vm.modal.form.$invalid;
        if (vm.modal.form.$invalid) {
            return false;
        }
        vm.largeComponentFileError = false;

        const data = new FormData();
        const fileInput = document.getElementById('questionImageFileInput');
        const files = fileInput ? fileInput.files : [];
        if (files.length) {
            const file = files[0];
            data.append('upload', file);
            if (vm.modal.data.image_file) {
                data.append('file_id', vm.modal.data.image_file.id);
            }
            let i = 0;
            for (let language in vm.modal.data.name) {
                const name = vm.modal.data.name[language];
                data.append('name[' + i + '][language]', language);
                data.append('name[' + i + '][value]', name.value ? name.value : '');
                i++;
            }

            if (vm.modal.data.question.answer.id) {
                data.append('id', vm.modal.data.question.answer.id);
            }
            data.append('answer', vm.modal.data.question.answer.answer);
            data.append('component_id', vm.modal.componentId);
            data.append('classifier_id', vm.modal.classifierId);
            data.append('object_id', vm.modal.objectId);
            data.append('question_id', vm.modal.data.question.id);
            if (vm.modal.data.image_created_date) {
                data.append('image_created_date', vm.modal.data.image_created_date.toDateString());
            }

            vm.modal.uploading = true;
            publicObjectsService.saveSurveyAnswer(data).then(function (response) {
                vm.modal.uploading = false;
                if (typeof response.data === 'string') {
                    console.log('error');
                } else {
                    let file = response.data;
                    if (file) {
                        if (!vm.modal.data.question.image_files) {
                            vm.modal.data.question.image_files = [];
                        }
                        const names = {};
                        for (let index in file.name) {
                            const name = file.name[index];
                            names[name.language] = name;
                        }
                        vm.modal.data.question.image_files.push({
                            id: file.id,
                            filename: file.filename,
                            name: names,
                            image_created_date: file.image_created_date
                        });
                        if (!vm.modal.data.question.answer.id) {
                            vm.modal.data.question.answer.id = vm.modal.data.question.image_files[0].reference_id;
                        }
                    }
                    vm.modalInstace.close();
                }
            });
        } else if(vm.modal.data.id) {
            publicObjectsService.saveEditedImageData(vm.modal.data).then((response) => {
                if (response.data === 'ok') {
                    vm.modalInstace.close(vm.modal.data);
                }
            });
        }
    };
};



/** WEBPACK FOOTER **
 ** ./app/shared/directives/objects/fill_component_surveys/modal/survey-question-image-files-modal.directive.js
 **/